import { ProductCreate } from './ProductCreate'
import { ProductEdit } from './ProductEdit'
import { ProductList } from './ProductList'
import { ProductShow } from './ProductShow'

export { ProductCreate, ProductEdit, ProductList, ProductShow }
